import React from "react";
import { ArrowUp, ArrowDown, Minus } from "@phosphor-icons/react";
import { monthLabel } from "./monthUtils";

export const Sparkline = ({ trend, threshold, testId }) => {
  const W = 120, H = 32, P = 3;
  const vals = trend.map((t) => t.avg).filter((v) => v != null);
  if (vals.length === 0) return <span className="text-[10px] text-zinc-400">—</span>;
  const max = Math.max(...vals, threshold) * 1.1;
  const min = Math.min(...vals, threshold) * 0.85;
  const x = (i) => P + (i * (W - 2 * P)) / (trend.length - 1);
  const y = (v) => H - P - ((v - min) / (max - min || 1)) * (H - 2 * P);
  const pts = trend.map((t, i) => (t.avg == null ? null : [x(i), y(t.avg), t])).filter(Boolean);
  return (
    <svg width={W} height={H} className="overflow-visible" data-testid={testId}>
      <line x1={P} x2={W - P} y1={y(threshold)} y2={y(threshold)} stroke="#dc2626" strokeDasharray="3 3" strokeWidth="1" opacity="0.6" />
      <polyline points={pts.map((p) => `${p[0]},${p[1]}`).join(" ")} fill="none" stroke="#18181b" strokeWidth="1.5" />
      {pts.map(([px, py, t]) => (
        <circle key={t.month} cx={px} cy={py} r="2.5" fill={t.avg > threshold ? "#dc2626" : "#059669"}>
          <title>{`${monthLabel(t.month)} : ${t.avg} L/100`}</title>
        </circle>
      ))}
    </svg>
  );
};

export const TrendDiff = ({ diff, testId }) => {
  if (diff == null) return <span className="text-[10px] text-zinc-400 uppercase tracking-widest" data-testid={testId}>Nouveau</span>;
  const up = diff > 0.05, down = diff < -0.05;
  const Icon = up ? ArrowUp : down ? ArrowDown : Minus;
  const cls = up ? "text-red-600" : down ? "text-emerald-700" : "text-zinc-500";
  return (
    <span className={`inline-flex items-center gap-0.5 mono text-xs font-bold ${cls}`} data-testid={testId} title="Écart avec le mois précédent">
      <Icon size={12} weight="bold" /> {diff > 0 ? "+" : ""}{diff.toFixed(2)}
    </span>
  );
};
